module.exports = __webpack_public_path__ + "img/icon_ok.44778b30.svg";